import { call, put, takeLatest } from "redux-saga/effects";
import { auditActions } from "../actions";
import api from "../services/audit.services";
import ACTIONS from "../constants";

function* getAuditLogList(state) {
  try {
    yield put(auditActions.getAuditLogList.pending);
    const response = yield call(api.auditLogListRequest, state.payload);
    yield put(auditActions.getAuditLogList.success(response ?? {}));
  } catch (error) {
    yield put(auditActions.getAuditLogList.error(error));
  }
}

function* getEntityActivity(state) {
  try {
    yield put(auditActions.getEntityActivity.pending);
    const { entityType, entityId, ...params } = state.payload;
    const response = yield call(api.entityActivityRequest, entityType, entityId, params);
    // apiCall.get already unwraps axios response.data (Laravel paginator shape).
    yield put(auditActions.getEntityActivity.success(response ?? {}));
  } catch (error) {
    yield put(auditActions.getEntityActivity.error(error));
  }
}

function* getAuditLogEntityTypes() {
  try {
    yield put(auditActions.getAuditLogEntityTypes.pending);
    const response = yield call(api.entityTypesRequest);
    if (response) {
      yield put(auditActions.getAuditLogEntityTypes.success(response));
    }
  } catch (error) {
    yield put(auditActions.getAuditLogEntityTypes.error(error));
  }
}

function* exportAuditLog(state) {
  try {
    yield put(auditActions.exportAuditLog.pending);
    const response = yield call(api.auditLogExportRequest, state.payload);
    if (response) {
      const blob = new Blob([response], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "audit-log-export.csv";
      link.click();
      window.URL.revokeObjectURL(url);
      yield put(auditActions.exportAuditLog.success(response));
    }
  } catch (error) {
    yield put(auditActions.exportAuditLog.error(error));
  }
}

export default function* auditSagas() {
  yield takeLatest(ACTIONS.AUDIT_LOG_LIST_CALL, getAuditLogList);
  yield takeLatest(ACTIONS.ENTITY_ACTIVITY_CALL, getEntityActivity);
  yield takeLatest(ACTIONS.AUDIT_LOG_ENTITY_TYPES_CALL, getAuditLogEntityTypes);
  yield takeLatest(ACTIONS.AUDIT_LOG_EXPORT_CALL, exportAuditLog);
}
